import { useRef, useEffect } from "react";
import M from "materialize-css";

export const useTooltip = () => {
  const tooltipRef = useRef(null);

  useEffect(() => {
    const el = tooltipRef.current;
    const instance = M.Tooltip.init(el);
    return () => {
      if (instance) {
        instance.destroy();
      }
    };
  }, [tooltipRef]);

  return tooltipRef;
};
